export default "__VITE_ASSET__B8KT0oW2__"